import { PageLink, PageTitle } from "../../../core/PageData";
import { useTranslation } from "react-i18next";

const MobileNavigation = () => {
  const { t } = useTranslation();
  const usersBreadcrumbs: Array<PageLink> = [
    {
      title: t("HeaderBar.Button.Profile"),
      path: "/profile/waba-account/list",
      isSeparator: false,
      isActive: false,
    },
    {
      title: "",
      path: "",
      isSeparator: true,
      isActive: false,
    },
  ];

  console.log("Campaign Tools Page");

  return <div>Setting Navigation</div>;
};

export default MobileNavigation;
